import { changeselectedtype } from '../Actions/ActionTypes';

const initialState = {
    selectedType: null,
}

const SelectedTypeReducer = (state = initialState, action) => {
    switch(action.type){
        case changeselectedtype: 
            return ({
                ...state,
                selectedType: action.selectedType
            })
        default :
            return state
    }

}

export default SelectedTypeReducer;